import axios from 'axios'
import constants from '../constants'
import {
  AmalgamWasteItem,
  AmalgamWasteResponse,
  PracticeAmalgamCompliance,
  MedicalWasteItem,
  MedicalWasteResponse,
  PracticeMwasteCompliance,
  PharmaceuticalWasteItem,
  PharmaceuticalWasteItemResponse,
  PracticePharmaCompliance
} from '../views/practice/wastemanagement/types'

const getAmalgamWaste = async (customerNumber: string) => {
  try {
    const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/amalgam/compliance`)
    const amalgamWaste: AmalgamWasteResponse = response.data

    return amalgamWaste
  } catch (error) {
    console.error(error)

    const amalgamWaste = {
      amalgam_containers: [] as AmalgamWasteItem[],
      practice_amalgam_compliance: {} as PracticeAmalgamCompliance,
    } as AmalgamWasteResponse

    return amalgamWaste
  }
}

const getMedicalWaste = async (customerNumber: string) => {
  try {
    const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/mwastes/compliance`)
    const medicalWaste: MedicalWasteResponse = response.data

    return medicalWaste
  } catch (error) {
    console.error(error)

    const medicalWaste = {
      mwaste_containers: [] as MedicalWasteItem[],
      practice_mwaste_compliance: {} as PracticeMwasteCompliance,
    } as MedicalWasteResponse

    return medicalWaste
  }
}

const getPharmaceuticalWaste = async (customerNumber: string) => {
  try {
    const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/pharmas/compliance`)
    const pharmaceuticalWaste: PharmaceuticalWasteItemResponse = response.data

    return pharmaceuticalWaste
  } catch (error) {
    const pharmaceuticalWaste = {
      pharma_containers: [] as PharmaceuticalWasteItem[],
      practice_pharma_compliance: {} as PracticePharmaCompliance,
    } as PharmaceuticalWasteItemResponse

    return pharmaceuticalWaste
  }
}

export { getAmalgamWaste, getMedicalWaste, getPharmaceuticalWaste }
